import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@/components/ui/collapsible";
import { ChevronDown, Lock } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const CalendarLegend = ({ courses, colors, locked }) => (
  <Collapsible>
    <CollapsibleTrigger data-testid="cal-legend-toggle" className="text-sm text-primary flex items-center gap-1 group">
      Legenda colori e stati <ChevronDown size={14} className="transition-transform group-data-[state=open]:rotate-180" />
    </CollapsibleTrigger>
    <CollapsibleContent data-testid="cal-legend" className="mt-2 rounded-lg border border-border bg-card p-3 space-y-3">
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1.5">
        {courses.map((c) => (
          <li key={c} className="flex items-start gap-2 text-sm"><span className="mt-1 w-3 h-3 rounded-full shrink-0" style={{ background: colors[c] }} /><span className="break-words">{c}</span>
            {locked?.has(c) && <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground shrink-0" data-testid={`cal-legend-locked-${c}`}><Lock size={12} /> bloccato</span>}</li>
        ))}
      </ul>
      <div className="flex flex-wrap gap-2">
        {["regular", "moved", "recovery", "cancelled"].map((s) => <StatusBadge key={s} status={s} />)}
      </div>
    </CollapsibleContent>
  </Collapsible>
);
